import React, { useState } from "react";
import { CUSTOMER_REVIEW } from "../../constants";
import { useBrand } from "../../hooks/useBrand";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faCopy, faCircleExclamation, faEnvelope } from "@fortawesome/free-solid-svg-icons";

export default function PostSuccess({ compensate, onNext, onBack }) {
  const [reviewRating, setReviewRating] = useState("");
  const [copied, setCopied] = useState(false);
  const brand = useBrand();
  const tagStyle = {
    fontWeight: "700",
    backgroundColor: "#f68b3c",
    color: "#fff",
    width: "130px", // FIXED WIDTH (important)
    height: "36px", // FIXED HEIGHT
    borderRadius: "8px",
    display: "flex", // for perfect centering
    alignItems: "center",
    justifyContent: "center",
    marginTop: "8px",
    fontSize: "18px",
  };

  const submitReview = (reviewRating) => {
    setReviewRating(reviewRating);
    CUSTOMER_REVIEW(compensate, reviewRating);

    // Redirect to external URLs based on rating and brand
    if (reviewRating === "Fairly Good") {
      // window.location.href = brand.reviewUrls.customerReview;
      window.open(brand.reviewUrls.customerReview, '_blank', 'noopener,noreferrer');
    } else if (reviewRating === "Good" || reviewRating === "Excellent") {
      // Use brand-specific probabilities for Google vs Trustpilot
      const googleProbability = brand.reviewProbabilities?.google ?? 0.6;
      const randomValue = Math.random();
      const reviewUrl =
        randomValue < googleProbability
          ? brand.reviewUrls.google
          : brand.reviewUrls.trustpilot;
      // window.location.href = reviewUrl;
      window.open(reviewUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(brand.supportEmail);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <div className="fdc-form text-center" data-testid="page-post-success">
        <h2 className="title">Thank you for submitting your claim.</h2>
        <p>
          We'd love to know how you would rate your experience with us by
          selecting one of the below.
        </p>
        <hr
          style={{
            border: "none",
            borderTop: "4px solid #bdbdbd", // light gray
            width: "90%", // adjust width like design
            margin: "20px auto", // center + spacing
          }}
        />
      </div>
      <div className="fdc-form gif-input">
        <div className="row">
          <div className="col-md-12">
            <div className="form-block review-popup d-flex justify-content-center">
              <div className="form-block review-popup d-flex justify-content-center">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "50px", // key fix
                  }}
                >
                  <button
                    onClick={() => submitReview("Fairly Good")}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      width: "120px", // slightly reduced for better spacing
                    }}
                  >
                    <img
                      src="/icons/Fairly-Good.png"
                      style={{ transform: "scale(1.5)", marginBottom: "8px" }}
                    />
                    <span style={tagStyle}>Fairly Good</span>
                  </button>

                  <button
                    onClick={() => submitReview("Good")}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      width: "120px",
                    }}
                  >
                    <img
                      src="/icons/Good.png"
                      style={{ transform: "scale(1.5)", marginBottom: "8px" }}
                    />
                    <span style={tagStyle}>Good</span>
                  </button>

                  <button
                    onClick={() => submitReview("Excellent")}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      width: "120px",
                    }}
                  >
                    <img
                      src="/icons/Excellent.png"
                      style={{ transform: "scale(1.5)", marginBottom: "8px" }}
                    />
                    <span style={tagStyle}>Excellent</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <hr
            style={{
              border: "none",
              borderTop: "4px solid #bdbdbd", // light gray
              width: "90%", // adjust width like design
              margin: "20px auto", // center + spacing
            }}
          />

          {/* <div className="col-md-12">
            <div className="form-block text-center">
              <p>
                If you have any questions you can email us at{" "}
                <a href={`mailto:${brand.email}`}>{brand.email}</a>.
              </p>
              <p>
                We will send you a Welcome communication which will detail what
                happens next.
              </p>
              <p>Thank you for choosing {brand.displayName}!</p>
            </div>
          </div> */}
          <div className="col-md-12">
            <div className="box-message fw-semibold theme-color-1 text-center pt-3 pb-3 px-3">
              <div className="text-center mb-3">
                <FontAwesomeIcon icon={faEnvelope} style={{ fontSize: "40px", color: "var(--ycm-orange)" }} />
              </div>
              <p style={{ marginBottom: "10px" }}>
                We’ve sent you a confirmation email, if you haven’t received it please check your ‘Junk’ or ‘Spam’ folders.
              </p>
            </div>
          </div>
          <div className="col-md-12" style={{ marginTop: "-16px" }}>
            <div className="box-message fw-semibold theme-color-1 text-center pt-3 pb-3 px-3">
              <p style={{ marginBottom: "8px", fontSize: "18px", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                <FontAwesomeIcon icon={faCircleExclamation} style={{ fontSize: "20px", color: "var(--ycm-orange)" }} />
                <strong>Keep an eye on your inbox</strong>
              </p>
              <p style={{ marginBottom: "12px", fontSize: "14px" }}>
                Your claim updates will arrive from:
              </p>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    backgroundColor: "#fff",
                    border: "2px solid var(--ycm-orange)",
                    borderRadius: "8px",
                    padding: "8px 16px",
                    fontWeight: "700",
                    fontFamily: "monospace",
                    fontSize: "16px",
                    margin: "8px 0 16px",
                  }}
                >
                  {brand.supportEmail}
                  <button
                    onClick={handleCopyEmail}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      padding: "0",
                      display: "flex",
                      alignItems: "center",
                    }}
                    title="Copy email to clipboard"
                  >
                    <FontAwesomeIcon
                      icon={faCopy}
                      style={{
                        fontSize: "14px",
                        color: copied ? "#28a745" : "#666",
                        transition: "color 0.3s ease",
                      }}
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
